<template>
  <div class="w-footer">
    <div class="w_footer_logo">
      <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_logo2.png" alt="" />
    </div>
    <div class="w-footer_box">
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-box_text">
          <div class="w-moduleBanner_text">400-626-5529</div>
          <div class="w-nonParagraph_text">{{ this.$t('home.footerText1') }}</div>
          <div class="w-nonParagraph_text">{{ this.$t('home.footerText2') }}</div>
          <div class="w-nonParagraph_text">{{ this.$t('home.footerText3') }}</div>
        </div>
      </Animation>
      <div class="w-logo_box">
        <Animation defaultClass="w-transform_top" animationClass="w-transform_show" style="display: block;">
          <div>
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_code.png" alt="" />
          </div>
        </Animation>
        <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
          <div class="w-logo_text w-nonParagraph_text">{{ this.$t('home.wxErcode') }}</div>
        </Animation>
      </div>
    </div>
    <div class="RecordNumber">
      <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/Officialwebsite/beian.png" style="margin-right: 5px;vertical-align: middle;">
      <a href="https://beian.miit.gov.cn/" target="_blank" class="btngov">
        沪ICP备13002254号-3
      </a>
      <span class="w-nonParagraph_text">&nbsp&nbspCopyright ©上海旭宇信息科技有限公司</span>
    </div>
  </div>
</template>

<script>
import Animation from '@/components/Animation.vue'

export default {
  props: {},
  data () {
    return {}
  },
  methods: {},
  components: { Animation }
}
</script>

<style scoped lang="scss">

</style>
